//// Application Packages
import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { format } from 'date-fns'

//// Application Slices
import { selectSettings } from '../../reducers/settingSlice'
import {
    updateFormData,
    updateFormValidity,
    selectForms,
} from '../../reducers/formSlice'

//// Application Components

//// Carbon Components
import { RadioButton, RadioButtonGroup } from '@carbon/react'

//// Carbon Icons

//// Static Constants

//////// Component
const AdditionalCriminalAndMedicaidMedicareFraudQuestionsConvictedGuiltyMedicareMedicaid =
    () => {
        //////// Hooks
        const dispatch = useDispatch()

        //////// State

        //////// Slices
        const settingsData = useSelector(selectSettings)
        const formsData = useSelector(selectForms)

        //// Slice Data
        const digital_name = settingsData?.['form']?.['digital_name']

        //////// Search Params

        //////// Methods

        // Re-Validate Data Submission
        const revalidation = async (event_name) => {
            // Update Validation State
            if (digital_name && event_name) {
                dispatch(
                    updateFormValidity({
                        digital_name: digital_name,
                        errors: {
                            [event_name]: false,
                            [event_name + 'ErrMsg']: '',
                        },
                    })
                )
            }
        }

        //////// Functional Methods

        // Handle Data Of All Fields + DatePicker (ID)
        const handleData = (e, id) => {
            if (e?.target?.name && e?.target?.value) {
                dispatch(
                    updateFormData({
                        digital_name: digital_name,
                        values: {
                            [e.target.name]: e.target.value,
                        },
                    })
                )
                revalidation(e.target.name)
            } else if (e?.target?.name) {
                dispatch(
                    updateFormData({
                        digital_name: digital_name,
                        values: { [e.target.name]: '' },
                    })
                )
                revalidation(e.target.name)
            } else if (e?.length > 0 && id) {
                dispatch(
                    updateFormData({
                        digital_name: digital_name,
                        values: {
                            [id]: format(new Date(e?.[0]), 'MM/dd/yyyy'),
                        },
                    })
                )
                revalidation(id)
            }
            //// Start Watson Assistant Journey

            //// End Watson Assistant Journey
        }

        //////// Memoization

        //////// Effects/Side Effects

        //////////////// Render & Return
        if (formsData?.[digital_name]?.values?.FEDFEL === 'Y') {
            return (
                <>
                    <RadioButtonGroup
                        className={
                            formsData?.[digital_name]?.errors?.FEDFEL2A
                                ? 'required invalid'
                                : 'required'
                        }
                        defaultSelected={
                            formsData?.[digital_name]?.values?.FEDFEL2A
                        }
                        valueSelected={
                            formsData?.[digital_name]?.values?.FEDFEL2A
                        }
                        legendText="Has it been more than 15 years before the date of application since the sentence and any subsequent period of probation for such conviction or plea ended?"
                        name="FEDFEL2A"
                        invalid={formsData?.[digital_name]?.errors?.FEDFEL2A}
                        invalidText={
                            formsData?.[digital_name]?.errors?.FEDFEL2AErrMsg
                        }
                    >
                        <RadioButton
                            id="FEDFEL2ATrue"
                            name="FEDFEL2ATrue"
                            labelText="Yes"
                            value="Y"
                            type="radio"
                            onClick={handleData}
                        />
                        <RadioButton
                            id="FEDFEL2AFalse"
                            name="FEDFEL2AFalse"
                            labelText="No"
                            value="N"
                            type="radio"
                            onClick={handleData}
                        />
                    </RadioButtonGroup>
                </>
            )
        }
    }

export default AdditionalCriminalAndMedicaidMedicareFraudQuestionsConvictedGuiltyMedicareMedicaid
